import { emptyList, ItemList } from '../../../common/models/ItemList'
import { Observable, of } from 'rxjs'
import { Container, IInit } from '../../../common/container/Container'
import { HTTP_CLIENT_KEY, IHTTPClient } from '../../../common/api/HTTPClient'
import { IStatusService } from '../../../common/status/StatusService'
import { STATUS_SERVICE_KEY } from '../../../container/app'
import { Query } from '../../../common/api/Query'
import { PatientParam, PatientParamDTO, toModel } from '../models/PatientParam'
import { PatientContainerConfig } from '../container'
import { prepareURL } from '../../../common/api/http-helpers'
import { catchError, map } from 'rxjs/operators'

export interface IPatientParamApi extends IInit {
  getByID(id: string): Observable<PatientParam | undefined>
  getFilteredList(q: Query<PatientParam>): Observable<ItemList<PatientParam>>
  add(e: PatientParamDTO): Observable<PatientParam | undefined>
  update(e: PatientParamDTO): Observable<PatientParam | undefined>
  delete(id: string): Observable<boolean>
}

export class PatientParamApi implements IPatientParamApi {
  private _container!: Container
  private _httpClient!: IHTTPClient
  private _url!: string
  private _statusService!: IStatusService

  init(c: Container) {
    this._container = c
    this._httpClient = this._container.get<IHTTPClient>(HTTP_CLIENT_KEY)
    this._statusService = this._container.get<IStatusService>(STATUS_SERVICE_KEY)
    this._url = (this._container.config as PatientContainerConfig).moduleFullUrlPatientParams
  }

  add(e: PatientParamDTO): Observable<PatientParam | undefined> {
    return this._httpClient.post<PatientParam>({ url: this._url, body: e }).pipe(
      map<PatientParamDTO, PatientParam>((d) => toModel(d)),
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(undefined)
      })
    )
  }

  delete(id: string): Observable<boolean> {
    return this._httpClient.delete({ url: this._url + '/' + id }).pipe(
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(false)
      })
    )
  }

  getByID(id: string): Observable<PatientParam | undefined> {
    return this._httpClient.get<PatientParam>({ url: `${this._url}/${id}` }).pipe(
      map<PatientParamDTO, PatientParam>((d) => toModel(d)),
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(undefined)
      })
    )
  }

  getFilteredList(q: Query<PatientParam>): Observable<ItemList<PatientParam>> {
    return this._httpClient.get<ItemList<PatientParam>>({ url: prepareURL(this._url, q) }).pipe(
      map<ItemList<PatientParamDTO>, ItemList<PatientParam>>((dto) => {
        const itemList = emptyList<PatientParam>()
        itemList.count = dto.count
        itemList.items = dto.items.map((d) => toModel(d))
        return itemList
      }),
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(emptyList<PatientParam>())
      })
    )
  }

  update(e: PatientParamDTO): Observable<PatientParam | undefined> {
    return this._httpClient.put<PatientParam>({ url: this._url, body: e }).pipe(
      map<PatientParamDTO, PatientParam>((d) => toModel(d)),
      catchError((err) => {
        this._statusService.sendStatus({ variant: 'error', error: err })
        return of(undefined)
      })
    )
  }
}
